import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './script/filters';
import VueGraph from 'vue-graph'
import VueSocialSharing from 'vue-social-sharing'
import './gtm.js'

Vue.use(VueGraph)
Vue.use(VueSocialSharing);

Vue.config.productionTip = false

Vue.mixin({
  methods: {
    $evaluate: param => eval('this.'+param)
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
